import { DataQueryKey, UseDataQuery } from '../../../hooks/useDataQuery/dataQuery.types';
import { GetSuggestedProducts } from './products.types';

export const getFindProductCategoryKey = (productId: string): UseDataQuery['queryKey'] => [
  'products/category',
  productId,
];

export const getSuggestedProductsKey = (params: GetSuggestedProducts): UseDataQuery['queryKey'] => [
  DataQueryKey.SUGGESTED_PRODUCTS,
  undefined,
  {
    productIds: params.productIds,
    customerIds: params.customerIds,
    mainCustomerId: params.mainCustomerId,
    catalogEntityIds: params.catalogEntityIds,
  },
];
